import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import SurveyStatisticsPage from 'models/statistics/survey/page';
import SurveyStatisticsQuestion from 'models/statistics/survey/questions/question';
import SurveyPage from 'models/survey/page';
import './page.html';
import './page.scss';
import { SurveyStatisticsQuestionVMConfig } from './question';

export interface SurveyStatisticsPageVMConfig {
    surveyPage: SubscribableOrNullableValue<SurveyPage>
    surveyStatPage: SubscribableOrNullableValue<SurveyStatisticsPage>
}

@injectable()
export default class SurveyStatisticsPageVM {
    questions: Subscribable<Array<SurveyStatisticsQuestionVMConfig>>

    constructor(
        @inject(wccModules.componentConfig) config: SurveyStatisticsPageVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const surveyPage = ko.flattenComputed(config.surveyPage);
        const surveyStatPage = ko.flattenComputed(config.surveyStatPage);

        const surveyQuestions = surveyPage.pluck(p => p.questions, []);
        const surveyStatQuestions = surveyStatPage.pluck(p => 
            (<Array<SurveyStatisticsQuestion>><any>p.choiceQuestions())
                .concat(<Array<SurveyStatisticsQuestion>><any>p.blankQuestions())
                .concat(<Array<SurveyStatisticsQuestion>><any>p.rankQuestions()), []);

        const questions = surveyStatQuestions.map(statQuestion => (<SurveyStatisticsQuestionVMConfig>{
            surveyQuestion: surveyQuestions.find(q => q.questionId() == statQuestion.questionId()),
            surveyStatQuestion: statQuestion
        }));

        this.questions = questions.sortBy(q => ko.unwrap(q.surveyQuestion)?.order());

        ko.applyBindingsToNode(info.element, {
            'css': {
                'survey-statistics__page': true
            }
        });
    }
}